import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import Button from "components/Button";
import classNames from "classnames";
import { useIntl } from "react-intl";
import useLoginSignupStyles from "./styles";
import I18nKey from "translations/I18nKey";
import { AlertPopupMobile } from "components/AlertPopupMobile";
import { apiClient } from "api";
import { SetStateAction, useState } from "react";
import SimpleButton from "components/SimpleButton";

interface ConfirmResendVerifyInterface {
  userName: string;
  setIsOTPSend: React.Dispatch<SetStateAction<boolean>>;
  setShowConfirmResend: React.Dispatch<SetStateAction<boolean>>;
}

export const ConfirmResendVerify: React.FC<ConfirmResendVerifyInterface> = ({
  userName,
  setIsOTPSend,
  setShowConfirmResend,
}) => {
  const intl = useIntl();
  const isMobile = useMediaQuery("(max-width : 768px)");
  const classes = useLoginSignupStyles();
  const [otpErr, setOtpErr] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [success, setSuccess] = useState<boolean>(false);

  const handleResendCode = async () => {
    setIsLoading(true);
    await apiClient
      .resendOTP(userName)
      .then((res) => {
        if (res?.data.data) {
          setOtpErr("");
          setIsOTPSend(true);
          setShowConfirmResend(false);
        } else if (res.config.data.data.errors) {
          setOtpErr(res.config.data.data.errors);
        }
      })
      .catch((err) => {
        setOtpErr(err.response.data.errors);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box className={classNames(classes.signupConfirmMsgContainer)}>
            <Typography className={classNames(classes.signupConfirmMsg)}>
              {intl.formatMessage(
                {
                  id: I18nKey.VERIFY_USER_CONFIRM_MSG,
                },
                {
                  userVariable: userName,
                }
              )}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box className={classNames(classes.verifyBtnsContainer)}>
            <SimpleButton
              text={intl.formatMessage({
                id: I18nKey.VERIFY_ACCOUNT,
              })}
              className="verifyBtn"
              primary
              loading={isLoading}
              onClick={handleResendCode}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          {otpErr || alertMessage ? (
            <AlertPopupMobile
              loading={isLoading}
              isSuccess={success}
              alertMsg={otpErr || alertMessage}
              className={classNames(classes.alertPopupMobileconfirm, {
                mobile: isMobile,
                default: !isMobile,
              })}
            />
          ) : null}
        </Grid>
      </Grid>
    </>
  );
};
